import axios from "axios";
import { storage } from "../config/httpServiceConfig";
import url from "../config/urlServiceConfig";

const attachmentAPI = {
  getAll: () => axios.get(url.attachment),
  getById: id => {
    return storage.get(`${url.attachment}/${id}`, {
      responseType: "blob"
    });
  },
  create: body => {
    const formData = new FormData();
    if (Array.isArray(body)) {
      body.map(item => {
        return formData.append("file", item.file);
      });
    } else {
      formData.append("file", body.file);
    }
    return axios.post(url.attachment, formData);
  },
  getUserImage: user => {
    return storage.get(user?.UserProfilePicture, {
      responseType: "blob",
      headers: {
        "Cache-Control": "force-cache"
      }
    });
  },
  delete: id => axios.delete(`${url.attachment}/${id}`)
};

export default attachmentAPI;
